import type { Iso3166Alpha3Lower } from "../types/country-codes";
import type { ResolvedLocale } from "../types/resolved-locale";

function createCountryAllowlist<const Supported extends Iso3166Alpha3Lower>(
  supportedCountries: readonly Supported[],
) {
  const supportedCountrySet = new Set<string>(supportedCountries);

  function isSupported(country: Iso3166Alpha3Lower): country is Supported {
    return supportedCountrySet.has(country);
  }

  function resolve(country: Iso3166Alpha3Lower): Supported | undefined {
    return isSupported(country) ? country : undefined;
  }

  function resolveFromLocale(locale: ResolvedLocale): Supported | undefined {
    return resolve(locale.metadata.country.iso3166Alpha3Lower);
  }

  return {
    isSupported,
    resolve,
    resolveFromLocale,
    supportedCountries,
  };
}

export { createCountryAllowlist };
